import {
  ACCOUNT_FEATURE_GROUP,
  ACTIVITY_FEATURE_GROUP,
  API_KEYS_FEATURE_GROUP,
  ASSETS_FEATURE_GROUP,
  DOMAINS_FEATURE_GROUP,
  ORGANIZATION_FEATURE_GROUP,
  PRODUCTS_FEATURE_GROUP,
  RESOURCES_FEATURE_GROUP,
  ROLES_FEATURE_GROUP,
  SECURITY_FEATURE_GROUP,
  TEAM_FEATURE_GROUP,
} from '../features/administrative';

/**
 * Single source of truth for top-level navigation menu entries.
 *
 * Array order is the rendering order — both the Account dashboard and any
 * external service that consumes FRBAC will render items in this sequence.
 *
 * `groupGuid` references a FeatureGroup so visibility can be resolved with
 * "any access in the group" semantics via FEATURE_GROUP_REGISTRY.
 */
export type MenuRegistryEntry = {
  groupGuid: string;
  path: string;
  title: string;
};

export const MENU_ITEMS: MenuRegistryEntry[] = [
  { groupGuid: PRODUCTS_FEATURE_GROUP.guid, path: '/dashboard', title: 'Dashboard' },
  { groupGuid: ACCOUNT_FEATURE_GROUP.guid, path: '/profile', title: 'Profile' },
  { groupGuid: ORGANIZATION_FEATURE_GROUP.guid, path: '/organization', title: 'Organization' },
  { groupGuid: ASSETS_FEATURE_GROUP.guid, path: '/assets', title: 'Assets' },
  { groupGuid: TEAM_FEATURE_GROUP.guid, path: '/team', title: 'Team' },
  { groupGuid: ROLES_FEATURE_GROUP.guid, path: '/roles', title: 'Roles' },
  { groupGuid: ACTIVITY_FEATURE_GROUP.guid, path: '/activity', title: 'Activity' },
  { groupGuid: DOMAINS_FEATURE_GROUP.guid, path: '/domains', title: 'Domains' },
  { groupGuid: API_KEYS_FEATURE_GROUP.guid, path: '/keys', title: 'API' },
  { groupGuid: SECURITY_FEATURE_GROUP.guid, path: '/security', title: 'Security' },
  { groupGuid: RESOURCES_FEATURE_GROUP.guid, path: '/resources', title: 'Resources' },
];
